module.exports = __webpack_public_path__ + "static/media/avatar.7227d41e.svg";